import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useFlow } from "../context/FlowContext";
import { Reveal, stagger, item } from "./motion";
import { PremiumIcon } from "./PremiumIcon";

const ORDER = ["hogar", "mascotas", "acompanamiento", "recados"];

export const QueNecesitas = () => {
  const { t } = useLang();
  const { openClient } = useFlow();
  return (
    <section id="what" className="relative py-24 md:py-32 scroll-mt-24" data-testid="what">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <Reveal><span className="text-xs font-semibold uppercase tracking-[0.2em] text-forest">{t.what.eyebrow}</span></Reveal>
          <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-[1.1]">{t.what.title}</h2></Reveal>
          <Reveal delay={0.1}><p className="mt-4 text-lg text-ink-soft leading-relaxed">{t.what.subtitle}</p></Reveal>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ORDER.map((key) => {
            const cat = t.categories[key];
            return (
              <motion.div key={key} variants={item} className="group bg-white rounded-3xl p-8 border border-line hover:shadow-[0_24px_50px_rgb(3,33,42,0.10)] transition-all duration-500 hover:-translate-y-1 flex flex-col" data-testid={`what-card-${key}`}>
                <PremiumIcon category={key} />
                <h3 className="mt-5 font-heading text-2xl font-medium text-ink">{cat.label}</h3>
                <p className="mt-2 text-ink-soft leading-relaxed flex-1">{cat.desc}</p>
                <button onClick={() => openClient(key)} className="group/btn mt-6 inline-flex items-center gap-2 rounded-full bg-forest text-white font-semibold px-5 py-3 hover:bg-sage-deep transition-all duration-300 self-start" data-testid={`what-request-${key}`}>
                  {t.what.cta}
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
                </button>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
